import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getPaymentTypes = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/payment-type");
    const paymentTypes = res.data.data;
    if (paymentTypes) {
      localStorage.setItem("paymentTypes", JSON.stringify(paymentTypes));
    }
    
    dispatch({ type: CommonActionTypes.GET_PAYMENT_TYPE, payload: paymentTypes });
    return paymentTypes;
  } catch (err) {
    const message = err.response.data.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
